import { render, staticRenderFns } from "./BotaoWhatsappMobile.vue?vue&type=template&id=27207c60"
import script from "./BotaoWhatsappMobile.vue?vue&type=script&lang=js"
export * from "./BotaoWhatsappMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27207c60')) {
      api.createRecord('27207c60', component.options)
    } else {
      api.reload('27207c60', component.options)
    }
    module.hot.accept("./BotaoWhatsappMobile.vue?vue&type=template&id=27207c60", function () {
      api.rerender('27207c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/botao-whatsapp/components/BotaoWhatsappMobile.vue"
export default component.exports